import { apiPlugin, storyblokInit } from '@storyblok/react/rsc'
import { components } from '@vendure/marketing/feature-storyblok-components'

export const getStoryblokApi = storyblokInit({
  accessToken:
    process.env.SB_PREVIEW_TOKEN ?? process.env.NEXT_PUBLIC_SB_PUBLIC_TOKEN,
  use: [apiPlugin],
  components,
})
